import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllLeadServiceAsync = createAsyncThunk(
    "leadService/getAllLeadService",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/services`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getLeadTemlateName = createAsyncThunk(
    "getAllLeadTemplate/getAllLeadTemlateNames",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/templates/get-template-name`,
            RequestConfig(),
        );
        return response.data;
    },
);
